import { BaseRequest } from "./baseRequest";

export class ConfGraphicsRequest extends BaseRequest {  
  confSessionId?: number;
  configurationId?: number;
  fileType?: string;
  graphicsDecorationId?: number;
  graphicType?: number;
  graphicModes?: Array<number>;
}